import { Link } from '@inertiajs/react';
import { ArrowLeft } from 'lucide-react';
import type { ButtonHTMLAttributes } from 'react';
import { toInertiaUrl } from '../../lib/toInertiaUrl';
import { cn } from '../ui/utils';

type PageBackButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> & {
    href?: string;
    label?: string;
    className?: string;
};

function PageBackButton({
    href,
    label = 'Voltar',
    className,
    onClick,
    type = 'button',
    ...buttonProps
}: PageBackButtonProps) {
    const icon = <ArrowLeft size={20} strokeWidth={1.9} aria-hidden />;

    if (href) {
        return (
            <Link
                href={toInertiaUrl(href)}
                className={cn('nx-page-back-btn', className)}
                aria-label={label}
            >
                {icon}
            </Link>
        );
    }

    return (
        <button
            type={type}
            className={cn('nx-page-back-btn', className)}
            aria-label={label}
            onClick={onClick}
            {...buttonProps}
        >
            {icon}
        </button>
    );
}

export { PageBackButton };
export type { PageBackButtonProps };
